/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'AbsenceType',dictionary:{"de":{"general":{"name":"Name","description":"Beschreibung"},"isVacation":"Urlaub","isAccident":"Unfall","isBreak":"Pause","isSickleave":"Krankheit","isPregnant":"Schwangerschaft","isMaternityLeave":"Karenz"},"en":{"general":{"name":"Name","description":"Description"},"isVacation":"Vacation","isAccident":"Accident","isBreak":"Break","isSickleave":"Sick Leave","isPregnant":"Pregnancy","isMaternityLeave":"Maternity Leave"}}})
import { Login } from './Login';

export class AbsenceType extends _BaseModel {
	
	static toString() {
		return 'AbsenceType'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.AbsenceType.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'AbsenceType', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.AbsenceType.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'AbsenceType', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'AbsenceType', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'AbsenceType', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.AbsenceType'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof AbsenceType) || _BaseModel.t('rules.reference', {modelName:'AbsenceType', path:'meta.currentDocument'}) ],
				model: AbsenceType,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'AbsenceType', path:'meta.revisions'}) ],
				model: AbsenceType,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.AbsenceType.general.name'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'AbsenceType', path:'general.name'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'AbsenceType', path:'general.name'}) ],
},
    
	},
	
					
	description:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.AbsenceType.general.description'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'AbsenceType', path:'general.description'}) ],
},
    
	},
	
},
				
	isVacation:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isVacation'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isVacation'}) ],
},
    
	},
	
				
	isAccident:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isAccident'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isAccident'}) ],
},
    
	},
	
				
	isBreak:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isBreak'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isBreak'}) ],
},
    
	},
	
				
	isSickleave:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isSickleave'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isSickleave'}) ],
},
    
	},
	
				
	isPregnant:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isPregnant'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isPregnant'}) ],
},
    
	},
	
				
	isMaternityLeave:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.AbsenceType.isMaternityLeave'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'AbsenceType', path:'isMaternityLeave'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.AbsenceType._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, general={}, isVacation=false, isAccident=false, isBreak=false, isSickleave=false, isPregnant=false, isMaternityLeave=false, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.general=GeneralClass.create(general);
		this.isVacation=isVacation;
		this.isAccident=isAccident;
		this.isBreak=isBreak;
		this.isSickleave=isSickleave;
		this.isPregnant=isPregnant;
		this.isMaternityLeave=isMaternityLeave;
		this._id=_id;
	}

	static create(data) {
		return new AbsenceType(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof AbsenceType || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : AbsenceType.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof AbsenceType ? item : AbsenceType.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class GeneralClass {
	constructor({name='', description='', }={}){
		this.name=name;
		this.description=description;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}
